export const snakeToCamelCase = str =>
  str.replace(/([-_]\w)/g, letter => letter[1].toUpperCase());

export const camelToSnakeCase = str =>
  str.replace(/[A-Z]|[0-9]/g, letter => `_${letter.toLowerCase()}`);

export const camelKeysToSnakeCaseKeys = convertObj => {
  if (typeof convertObj !== 'object') return convertObj;
  const obj = { ...convertObj };

  for (let oldName in obj) {
    // Camel to underscore
    const newName = camelToSnakeCase(oldName);

    // Only process if names are different
    if (newName !== oldName) {
      // Check for the old property name to avoid a ReferenceError in strict mode.
      if (obj.hasOwnProperty(oldName)) {
        obj[newName] = obj[oldName];
        delete obj[oldName];
      }
    }

    // Recursion
    if (typeof obj[newName] === 'object') {
      obj[newName] = camelKeysToSnakeCaseKeys(obj[newName]);
    }
  }
  return { ...obj };
};

export const snakeKeysToCamelCaseKeys = convertObj => {
  if (typeof convertObj !== 'object') return convertObj;
  const obj = { ...convertObj };

  for (let oldName in obj) {
    // Camel to underscore
    const newName = snakeToCamelCase(oldName);

    // Only process if names are different
    if (newName !== oldName) {
      // Check for the old property name to avoid a ReferenceError in strict mode.
      if (obj.hasOwnProperty(oldName)) {
        obj[newName] = obj[oldName];
        delete obj[oldName];
      }
    }

    // Recursion
    if (typeof obj[newName] === 'object') {
      obj[newName] = snakeKeysToCamelCaseKeys(obj[newName]);
    }
  }
  return { ...obj };
};



// WEBPACK FOOTER //
// ./src/utils/caseConvertors.js